import Vue from "vue";
import VueRouter from "vue-router";
import index from "../router/home/index";
import auth from "../router/auth/auth";
import shopCart from "../router/shopCart/shopCart";
import productList from "./product/product";
import user from "./user/user";
import provider from "./provider/provider";
import newOrder from "./order/newOrder";
import search from "./search/search";
import batchOrder from "./order/newOrder";
import bookList from "./order/newOrder";
import company from "./public/public";

import store from "../store/index";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  { path: "/", redirect: "/home" },
  index, //首页
  ...auth, //权限 登录注册
  ...shopCart, //购物车
  ...user, // 用户面板
  ...provider, //供应商模块
  ...newOrder,
  ...batchOrder,
  ...bookList,
  ...productList,
  search,
  ...company,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  window.document.title = to.name + " ~ 京麦通";
  if (to.fullPath == "/newOrder") {
    window.sessionStorage.setItem("ts", JSON.stringify(to.params));
  }
  if (to.meta.requireAuth) {
    store.commit("initUser");
    let isNaName = store.getters.isNaName;
    store.getters.isNaName;
    if (isNaName) {
      next({ path: "/login", query: { redirect: to.fullPath, name: to.name } });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
